import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddUserFailure,
  AddUserFreePremiumFailure,
  AddUserFreePremiumSuccess,
  AddUserSuccess,
  EditUserFailure,
  EditUserSuccess,
  SendAdminMessageFailure,
  SendAdminMessageSuccess,
} from '../../Redux/Actions/UsermanageAction';
import { ADD_USER, ADD_USER_FREE_PREMIUM, EDIT_USER, SEND_ADMIN_MESSAGE } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddUserEpic = action$ =>
  action$.pipe(
    ofType(ADD_USER),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addUser`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.usermanagement, toast.success(response.response.Message));
              return of(AddUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(AddUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EditUserEpic = action$ =>
  action$.pipe(
    ofType(EDIT_USER),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editUser`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const SendAdminMessageEpic = action$ =>
  action$.pipe(
    ofType(SEND_ADMIN_MESSAGE),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/sendMessage`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.usermanagement, toast.success(response.response.Message));
              return of(SendAdminMessageSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(SendAdminMessageFailure(response.response));
            }
          }),
        ),
    ),
  );

export const AddFreePremiumEpic = action$ =>
  action$.pipe(
    ofType(ADD_USER_FREE_PREMIUM),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/FreeSubscription`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.usermanagement, toast.success(response.response.Message));
              return of(AddUserFreePremiumSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(AddUserFreePremiumFailure(response.response));
            }
          }),
        ),
    ),
  );
